import React, { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { PhoneInputProps } from 'components/uiKit.todo/PhoneInput'
import PhoneInput from 'components/uiKit.todo/PhoneInput'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldPhone: React.FC<IControlProps<PhoneInputProps>> = ({
  name,
  onChange,
  defaultValue,
  value,
  ...restProps
}) => {
  const onChangeWrapper = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value: PhoneInputProps['value']) => onChange({ name, value: (value ?? null) as any }),
    [name, onChange],
  )
  return (
    <PhoneInput
      {...restProps}
      name={name}
      onChange={onChangeWrapper}
      value={value ?? (defaultValue as string)}
    />
  )
}

export default FieldPhone
